import { motion } from "framer-motion";
import logo from "../assets/wallpapers/LOGO.png";

export default function Hexagon3DGold({ size = 280 }) {
  const w = size;
  const h = size;
  const r = 0.44 * size;
  const cx = size / 2;
  const cy = size / 2;

  const hexPoints = (radius) => {
    const pts = [];
    for (let i = 0; i < 6; i++) {
      const angle = (Math.PI / 180) * (60 * i);
      const x = cx + radius * Math.cos(angle);
      const y = cy + radius * Math.sin(angle);
      pts.push(`${x},${y}`);
    }
    return pts.join(" ");
  };

  return (
    <motion.svg
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
      className="drop-shadow-2xl -ml-8"
      animate={{
        rotate: [0, 360],
        scale: [1, 1.05, 1],
        filter: [
          "drop-shadow(0 0 15px gold)",
          "drop-shadow(0 0 30px orange)",
          "drop-shadow(0 0 15px gold)",
        ],
      }}
      transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
    >
      <defs>
        <linearGradient id="gold" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFD76B" />
          <stop offset="50%" stopColor="#F7B500" />
          <stop offset="100%" stopColor="#8C6A1F" />
        </linearGradient>
      </defs>

      {/* Outer glowing hexagon (bigger) */}
      <polygon
        points={hexPoints(r + 30)}
        fill="transparent"
        stroke="url(#gold)"
        strokeWidth={10}
      />

      {/* Inner glowing hexagon (smaller) */}
      <polygon
        points={hexPoints(r)}
        fill="transparent"
        stroke="url(#gold)"
        strokeWidth={8}
      />

      {/* Logo fitted fully inside */}
      <image
        href={logo}
        x={cx - r * 0.9}
        y={cy - r * 0.9}
        width={r * 1.8}
        height={r * 1.8}
        preserveAspectRatio="xMidYMid meet"
        className="hover:scale-110 transition-transform duration-300"
      />
    </motion.svg>
  );
}
